import ShowSubject from './exam/subject/showSubject'
import SubjectForm from './exam/subject/subjectForm/subjectForm'
import ExamPreview from './exam/preview/preview'
import ExportExcel from './exportExcel'
import QsPreview from './questionnaire/preview'
import ExamPercent from './exam/percent/examPercent'
import LookOrgNodeCategory from './org/orgNodeCategory/lookOrgNodeCategory'
import PositionRadar from './position/positionRadar'
import CustomTabs from './Tabs/CustomTabs'
import GridLayouts from './gridLayouts'
import AudienceGroupItem from './audienceGroupItem';
import ReportConfig from './dataReport/reportConfigForm'
import ResumeExportView from'./resumeExport'
import WizTableListNew from "./wizTableListNew";


export {
    ShowSubject,
    SubjectForm,
    ExamPreview,
    QsPreview,
    ExportExcel,
    ExamPercent,
    LookOrgNodeCategory,
    PositionRadar,
    CustomTabs,
    GridLayouts,
    AudienceGroupItem,
    ReportConfig,
    ResumeExportView,
    WizTableListNew,

}
